<template>
  <div class="input">
    <div class="input-label">場所名</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="name">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    name: {
      get: function () {
        return this.$store.state.tourism.name
      },

      set: function (value) {
        this.$store.commit(
          'tourism/setName',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
